export class ListaTipoIdentificacion {
  public codigo: string;
  public desc: string;

  public static CC = new ListaTipoIdentificacion('CO1C', 'Cédula de ciudadanía');
  public static RC = new ListaTipoIdentificacion('CO1L', 'Registro civil');
  public static CE = new ListaTipoIdentificacion('CO1E', 'Cédula de extranjería');
  public static TI = new ListaTipoIdentificacion('CO1T', 'Tarjeta de identidad');
  public static PEP = new ListaTipoIdentificacion('CO1V', 'Permiso especial de permanencia');
  public static PA = new ListaTipoIdentificacion('CO1P', 'Pasaporte');
  public static PPT = new ListaTipoIdentificacion('CO1W', 'Permiso protección temporal');
  public static CD = new ListaTipoIdentificacion('CO1D', 'Carnet diplomático');
  public static NIT = new ListaTipoIdentificacion('CO1N', 'Nit');


  constructor(codigo: any, desc: string) {
    this.codigo = codigo;
    this.desc = desc
  }
}
